import { addReactError } from '@datadog/browser-rum-react';
import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fallback?: ReactNode | (() => ReactNode);
    beforeCapture?: (scope: any) => void;
}

interface State {
    hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error & { cause?: Error | undefined }, errorInfo: ErrorInfo): void {
        addReactError(error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            const { fallback } = this.props;
            if (fallback) {
                return typeof fallback === 'function' ? fallback() : fallback;
            }
            return null;
        }

        return this.props.children;
    }
}
